export default {
  userMenu: [
    {
      name: 'pi-transit',
      caption: 'ПИ и Транзит',
      parent_id: null,
      id: 28,
      link: '/pi-transit',
      children: []
    },
    {
      name: 'usermanagment_otvt',
      caption: 'Организации ОТВТ',
      parent_id: null,
      id: 28,
      link: '/otvt-groups-users',
      children: []
    }
  ]
}
